"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groqGetType = exports.groqGetDocumentById = void 0;

var groqGetDocumentById = function groqGetDocumentById() {
  return "*[_id == $id][0]";
};

exports.groqGetDocumentById = groqGetDocumentById;

var groqGetType = function groqGetType() {
  return "*[_type == $type]";
};

exports.groqGetType = groqGetType;